(function (root) {
  'use strict';
  var VERSION = '2026-09-29.3';
  function weights(c) {
    var entries=Object.entries(c.allocation || {A:1,B:1});
    return entries.length && entries.every(function(e){return /^(A|B|C)$/.test(e[0]) && Number.isFinite(e[1]) && e[1]>=0;}) && entries.some(function(e){return e[1]>0;}) ? entries : null;
  }
  function validAssignment(a,c) {
    return !!(a && a.experiment_id===c.experiment_id && a.signature===c.signature && a.content_version===c.version &&
      /^[a-f0-9]{32}$/.test(a.assignment_id) && weights(c) && weights(c).some(function(e){return e[0]===a.arm&&e[1]>0;}) &&
      (!c.assignment_scope || a.assignment_scope===c.assignment_scope) &&
      Number.isFinite(Date.parse(a.assigned_at)) && Date.parse(a.assigned_at)<=Date.now());
  }
  function assign(c,storage,crypto,now) {
    var key='nb_category_assignment::'+c.experiment_id, page=c.assignment_scope==='pageview', allocation=weights(c);
    try {
      if(!allocation || !crypto || !crypto.getRandomValues)return null;
      if(!page){
        var previous=JSON.parse(storage.getItem(key)||'null');
        if(previous && Number.isFinite(Date.parse(previous.assigned_at)) && now-Date.parse(previous.assigned_at)>180*86400000){storage.setItem(key,JSON.stringify({expired:true}));return null;}
        if(previous)return validAssignment(previous,c)?previous:null;
      }
      var bytes=new Uint32Array(5);crypto.getRandomValues(bytes);
      var total=allocation.reduce(function(sum,e){return sum+e[1];},0),pick=bytes[0]/4294967296*total,arm;
      allocation.some(function(e){pick-=e[1];if(pick<0){arm=e[0];return true;}return false;});
      var a={experiment_id:c.experiment_id,signature:c.signature,content_version:c.version,
        assignment_id:Array.from(bytes.slice(1),function(x){return x.toString(16).padStart(8,'0');}).join(''),
        arm:arm,assigned_at:new Date(now).toISOString(),entry_article_id:String(c.article_id),entry_category:c.category,
        entry_locale:c.locale,entry_market:c.market,entry_device:c.device_class||'unknown',origin:c.origin};
      if(c.assignment_scope)a.assignment_scope=c.assignment_scope;
      if(page){a.pageview_id=a.assignment_id;return a;}
      storage.setItem(key,JSON.stringify(a));return validAssignment(JSON.parse(storage.getItem(key)),c)?a:null;
    } catch(_){return null;}
  }
  function boot(doc, win) {
    var configNode=doc.querySelector('[data-nb-category-config]');
    if (!configNode || configNode.dataset.bound) return;
    configNode.dataset.bound='true';configNode.dataset.build='2026-10-17.1';
    var c; try {c=JSON.parse(configNode.textContent);} catch (_) {return;}
    if (!c.enabled || !c.article_id || !c.destination_verified || c.medical_context || !['aa','ab','abc'].includes(c.mode)) return;
    // Apply the explicit test marker to both counting paths before any event is sent.
    try {c.qa=!!c.qa || new URLSearchParams(win.location.search).get('nb_cta_qa')==='1';} catch (_) {}
    c.device_class=win.innerWidth<768?'mobile':win.innerWidth<1100?'tablet':'desktop';
    var cards=Array.from(doc.querySelectorAll('[data-nb-category-cta]'));
    var anonymousStages=new Set(), anonymousObservers=[], anonymousTimers=new Map();
    var assignment=null, suspendedAssignment=null, starting=false, consentGeneration=0, visualAssignment=null, observers=[], timers=new Map(), emitted=new Set(), pending=new Map();
    function allowed() {
      try {return win.Shopify.customerPrivacy.analyticsProcessingAllowed() === true;} catch (_) {return false;}
    }
    function publish(stage, card, heartbeat) {
      if (!assignment || !allowed()) return;
      var position=card ? card.dataset.position : 'assignment';
      var id=assignment.assignment_id+':'+stage+':'+String(c.article_id)+':'+position;
      if (emitted.has(id) && !heartbeat) return;
      if(['visible','placement_visible','click'].includes(stage))publish('assignment',null,true);
      var generation=consentGeneration;
      pending.set(id,{stage:stage,card:card});
      var data=Object.assign({},assignment,{stage:stage,article_id:String(c.article_id),position:position,
        message_id:c.message_id||(c.mode==='aa'||assignment.arm==='C'?'general_m1':c.mode==='abc'||c.contract_version===VERSION?'category_'+c.category+'_'+assignment.arm.toLowerCase()+'1':(assignment.arm==='A'?'general_m1':'category_'+c.category+'_m1')),
        locale:c.locale,market:c.market,measurement_qa:!!c.qa,contract_version:c.contract_version||'2026-09-29.1'});
      // One official custom event, consumed by the existing app pixel. Never fabricate purchase/cart events.
      try {
        if (!win.Shopify.analytics || !win.Shopify.analytics.publish) return;
        emitted.add(id);pending.delete(id);
        var result=win.Shopify.analytics.publish('nordbelt:category_cta',data);
        if (result && typeof result.catch==='function') result.catch(function(){if(generation===consentGeneration&&assignment&&assignment.assignment_id===data.assignment_id&&allowed()){emitted.delete(id);pending.set(id,{stage:stage,card:card});}});
      } catch (_) {emitted.delete(id);pending.set(id,{stage:stage,card:card});}
    }
    function visible(node) {
      if (doc.visibilityState==='hidden' || node.hidden || !node.getClientRects().length) return false;
      var style=win.getComputedStyle(node);
      if (style.visibility==='hidden' || style.display==='none' || Number(style.opacity)===0) return false;
      var r=node.getBoundingClientRect(), area=r.width*r.height;
      var intersection=Math.max(0,Math.min(r.bottom,win.innerHeight)-Math.max(r.top,0))*Math.max(0,Math.min(r.right,win.innerWidth)-Math.max(r.left,0));
      return area>0 && intersection/area>=0.5;
    }
    function countAnonymous(stage) {
      if (!c.anonymous_counts || c.assignment_scope!=='pageview' || !visualAssignment || !cards.length || anonymousStages.has(stage)) return;
      anonymousStages.add(stage);
      // Daily aggregate only: no IDs, cookies, storage, page URL, referrer or consent value.
      try {win.fetch('https://nordbelt-attribution.nordbelt-attribution.workers.dev/v1/cta-counts',{
        method:'POST',mode:'cors',credentials:'omit',referrerPolicy:'no-referrer',cache:'no-store',keepalive:true,
        headers:{'Content-Type':'text/plain'},body:JSON.stringify({experiment:c.experiment_id,arm:visualAssignment.arm,stage:stage,qa:!!c.qa})
      }).catch(function(){});}catch(_){}
      // No retry: a lost response must never create another aggregate count.
      if ((stage==='visible'||stage==='click') && anonymousStages.has('visible') && anonymousStages.has('click')) countAnonymous('visible_click');
    }
    function watchAnonymous() {
      if (!c.anonymous_counts || c.assignment_scope!=='pageview' || !visualAssignment || !win.IntersectionObserver || anonymousStages.has('visible')) return;
      cards.forEach(function(card){
        var observer=new win.IntersectionObserver(function(entries){entries.forEach(function(e){
          win.clearTimeout(anonymousTimers.get(card));anonymousTimers.delete(card);
          if(e.intersectionRatio>=0.5 && visible(card))anonymousTimers.set(card,win.setTimeout(function(){if(visible(card))countAnonymous('visible');},1000));
        });},{threshold:[0,0.5,1]});observer.observe(card);anonymousObservers.push(observer);
      });
    }
    function watch(node,stage,card) {
      if (!win.IntersectionObserver) return;
      var observer=new win.IntersectionObserver(function(entries){
        entries.forEach(function(e){
          win.clearTimeout(timers.get(node));timers.delete(node);
          if (e.intersectionRatio>=0.5 && visible(node) && allowed()) {
            timers.set(node,win.setTimeout(function(){if(visible(node)) publish(stage,card);},1000));
          }
        });
      },{threshold:[0,0.5,1]});observer.observe(node);observers.push(observer);
    }
    function render(a) {
      cards.forEach(function(card){
        var modern=!!card.querySelector('[data-nb-copy-set="C"]');
        var arm=c.same_visible_copy?'B':c.mode==='aa'||!a?(modern?'C':'A'):a.arm;
        var sets=card.querySelectorAll('[data-nb-copy-set]');
        sets.forEach(function(set){var active=set.dataset.nbCopySet===arm;var h=set.querySelector('h2');if(h)h.id='nb-category-active-'+c.article_id+'-'+card.dataset.position+'-'+set.dataset.nbCopySet;set.inert=!active;set.setAttribute('aria-hidden',String(!active));});
        card.dataset.mode=c.mode;
        var heading=card.querySelector('[data-nb-copy-set="'+arm+'"] h2');
        if(heading)card.setAttribute('aria-labelledby',heading.id);
        card.dataset.arm=a?a.arm:'unassigned';
      });
    }
    function activate() {
      if (!allowed()) return;
      if (assignment) return;
      try{
        if(c.assignment_scope!=='pageview' && suspendedAssignment && validAssignment(suspendedAssignment,c) && !win.localStorage.getItem('nb_category_assignment::'+c.experiment_id))win.localStorage.setItem('nb_category_assignment::'+c.experiment_id,JSON.stringify(suspendedAssignment));
        assignment=visualAssignment||assign(c,c.assignment_scope==='pageview'?null:win.localStorage,win.crypto,Date.now());
      }catch(_){return;}
      if (!assignment) return;
      render(assignment);publish('assignment');
      cards.forEach(function(card){
        publish('render',card);watch(card,'visible',card);
        var marker=doc.querySelector('[data-nb-cta-marker="'+card.dataset.position+'"]');
        if(marker)watch(marker,'placement_visible',card);
      });
    }
    function start() {
      if(!allowed()||assignment||starting)return;
      // One allocation across concurrent same-origin tabs. Locking never delays links.
      if(c.assignment_scope!=='pageview'&&win.navigator.locks){
        starting=true;
        win.navigator.locks.request('nb-category-assignment::'+c.experiment_id,function(){starting=false;if(allowed())activate();}).catch(function(){starting=false;});
      }else activate();
    }
    cards.forEach(function(card){
      card.addEventListener('click',function(event){var link=event.target.closest('a'),set=link&&link.closest('[data-nb-copy-set]');if(set && set.getAttribute('aria-hidden')!=='true'){countAnonymous('click');retry();publish('click',card);}});
    });
    doc.addEventListener('visibilitychange',function(){
      anonymousTimers.forEach(function(t){win.clearTimeout(t);});anonymousTimers.clear();
      anonymousObservers.forEach(function(o){o.disconnect();});anonymousObservers=[];
      if(doc.visibilityState==='visible')watchAnonymous();
      timers.forEach(function(t){win.clearTimeout(t);});timers.clear();
      // Re-observe after tab return to require a fresh continuous second.
      if(doc.visibilityState==='visible')retry();
      if(doc.visibilityState==='visible') observers.forEach(function(o){o.disconnect();});
      if(doc.visibilityState==='visible' && assignment){observers=[];cards.forEach(function(card){watch(card,'visible',card);var marker=doc.querySelector('[data-nb-cta-marker="'+card.dataset.position+'"]');if(marker)watch(marker,'placement_visible',card);});}
    });
    doc.addEventListener('visitorConsentCollected',function(){
      if(allowed()){start();return;}
      timers.forEach(function(t){win.clearTimeout(t);});timers.clear();observers.forEach(function(o){o.disconnect();});observers=[];
      consentGeneration++;
      if(c.assignment_scope!=='pageview'){suspendedAssignment=assignment||suspendedAssignment;try{win.localStorage.removeItem('nb_category_assignment::'+c.experiment_id);}catch(_){}visualAssignment=null;}
      assignment=null;emitted.clear();pending.clear();render(visualAssignment);
    });
    function retry(){if(!allowed())return;Array.from(pending.values()).forEach(function(e){publish(e.stage,e.card);});}
    win.addEventListener('online',retry);
    win.addEventListener('pageshow',function(){if(assignment){retry();publish('assignment');}else start();});
    doc.addEventListener('shopifyCustomerPrivacyApiLoaded',function(){start();retry();});
    if(c.assignment_scope==='pageview'){visualAssignment=assign(c,null,win.crypto,Date.now());render(visualAssignment);countAnonymous('render');watchAnonymous();}
    else render(null);
    start();
    // Explicit QA mode only. Native consent controls make opt-out delivery verifiable without console injection.
    if(new URLSearchParams(win.location.search).get('nb_cta_qa')==='1'){
      var panel=doc.createElement('aside'),status=doc.createElement('p');panel.setAttribute('aria-label','CTA-meettest');
      panel.style.cssText='position:fixed;bottom:8px;left:8px;z-index:2147483000;background:#fff;color:#101d2f;border:1px solid #253a54;border-radius:8px;padding:12px;font:14px system-ui;max-width:320px';
      function qaStatus(){status.textContent='TESTVERKEER · Analytics toegestaan: '+(allowed()?'ja':'nee');}
      qaStatus();panel.appendChild(status);
      [false,true].forEach(function(value){var button=doc.createElement('button');button.type='button';button.textContent=value?'Analytics toestaan':'Analytics weigeren';button.style.cssText='min-height:44px;margin:4px;padding:8px';
        button.addEventListener('click',function(){try{win.Shopify.customerPrivacy.setTrackingConsent({analytics:value},qaStatus);}catch(_){status.textContent='Privacy-API nog niet beschikbaar.';}});panel.appendChild(button);});
      doc.addEventListener('visitorConsentCollected',qaStatus);doc.addEventListener('shopifyCustomerPrivacyApiLoaded',qaStatus);doc.body.appendChild(panel);
    }
  }
  if (typeof module==='object' && module.exports) module.exports={assign:assign,validAssignment:validAssignment,boot:boot};
  if (root && root.document) boot(root.document,root);
})(typeof window==='undefined'?null:window);
